
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import Layout from 'components/Dashboard/Layout';
import { ListProvider, ListContext } from 'core/ListProvider';
import TableListFooter from 'core/TableListFooter';
import { ScheduleListTable } from './ListTable';
import { YellowButton } from '../../ui/Button';
import { ScheduleListFilter } from './ListFilter';
import { ScheduleListTableFilter } from './ListTableFilter';
import TableStickyHeader from "../../core/TableStickyHeader";
import { UserContext, hasAccountPermission } from 'components/User';


export default class ScheduleList extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Расписание';
  }

  onDetail = (item) => {
    if (!item.order) {
      this.props.history.push(`/schedule/${item.id}`);
    }
  };

  onDelete = (context, item) => {
    context.deleteItem(item);
  };

  render() {
    return (
      <ListProvider
        url={'schedule'}
      >
        <ListContext.Consumer>
          {context => {
            const { items, response, loading } = context;

            let addButton = hasAccountPermission(this.context, 'schedule.add_schedule')
              ? (
                <YellowButton to={'/schedule/add'} component={Link} startIcon={<AddIcon />}>
                  Добавить связку
                </YellowButton>
              )
              : undefined;

            return (
              <Layout rows={'auto auto 1fr'}>

                <Layout.Header
                  title={'Расписание'}
                  right={addButton}
                />

                <Layout.Filter>
                  <ScheduleListFilter context={context} />
                  <ScheduleListTableFilter context={context} />
                </Layout.Filter>

                <Layout.ContentSimple>
                  {response && (
                    <Paper>
                      <TableStickyHeader size={'small'} subtractHeight={260}>
                        <ScheduleListTable
                          context={context}
                          items={items}
                          onDetail={(item) => this.onDetail(item)}
                          onDelete={(item) => this.onDelete(context, item)}
                          loading={loading}
                        />
                      </TableStickyHeader>
                      <Table>
                        <TableListFooter colspan={6} showPerPageSelector={false} />
                      </Table>
                    </Paper>
                  )}
                </Layout.ContentSimple>

              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
